import React from "react";
import logoZago from "../../images/logo-zago.png";
import "../../css/search.css";

export default function HeaderLogo() {
  return (
    <div className="logo-container">
      <img className="logo-header" src={logoZago} alt="Groupe Zago" />
    </div>
  );
}
